<template>
    <SmsValidationContainer/>
</template>

<script>
    import SmsValidationContainer from '@modules/userProfile/smsValidation/SmsValidationContainer';

    export default {
        name: 'SmsValidationModal',
        components: {
            SmsValidationContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/SmsValidationModal.vue